import View from '../../components/view/view';
import { useSettingsStore } from '../../store/settings-store';

const MonitoringServicesView = () => {
    const { theme } = useSettingsStore();

    return (
        <View theme={theme}>
            <div className={'viewContent'}>
                <h1 className={'view-title'}>Solicitudes de emergencia</h1>
            </div>
        </View>
    );
};

export default MonitoringServicesView;
